export class ServiceActivationRequestModel {
    gasMeterNumber: string;
    subdivision: string;
    meter: string;
    requestedDate: Date;
    emailAddress: string;
    reEnterEmailAddress: string;
    builderCompanyName: string;
    aliasName: string;
    streetNumber: string;
    streetNameThoroughfar: string;
    prefix: any;
    isCornorLot: string;
    adjoinStreetName: string;
    contactName: string;
    contactPhoneNumber: string;
    contactPhoneNumberExtension: string;
    alternatePhoneNumber: string;
    alternatePhoneNumberExtension: string;
    marketerValue: any;
    streetAddress: string;
    state: string;
    city: string;
    zipCode: string;
    specialNotes: string;
    closeMainIntrStr: string;
    directionPrefix: string;
}
